// extracted by mini-css-extract-plugin
export default {"page":"CourseProjection_page__XRgrO"};